module.exports = __webpack_public_path__ + "static/banner-b441ac1942e8b80210c513e9bfafd814.png";